export default {
  shokzRateQuery: {
    rateTypes: {
      fcl: '海运整箱',
      lcl: '海运拼箱',
      air: '空运',
      prePort: '港前',
      lastMile: '尾程'
    },
    fields: {
      priceNo: '运价编码',
      validDate: '有效期',
      supplierIds: '供应商',
      carrierIds: '船公司',
      airCarrierIds: '航空公司',
      cargoTypes: '货物类型',
      onePrice: 'ALL IN 价',
      combinationType: '组合方式',
      originCountryId: '起运国家',
      destinationCountryId: '目的国家',
      routeIds: '卸货港航线',
      directFlag: '直达/中转',
      transitPortIds: '中转港',
      transitAirportIds: '中转机场',
      polId: '起运港',
      podId: '卸货港',
      departureAirportId: '起运机场',
      arrivalAirportId: '目的机场',
      wharfIds: '码头',
      segmentTransportMode: '运输方式',
      loadingPortId: '装货港',
      loadingStationId: '装货站',
      addressType: '地址类型',
      warehouseId: '仓库',
      originNodeCountryId: '起运国',
      originNodeSeaportId: '起运港',
      originNodeTerminalId: '起运码头',
      originNodeAirportId: '起运机场',
      unloadingCountryId: '卸货国家',
      unloadingSeaportId: '卸货港',
      unloadingTerminalId: '卸货码头',
      unloadingAirportId: '卸货机场',
      destinationId: '目的地',
      serviceType: '服务类型',
      level1Id: '国家/地区',
      level2Id: '省/州',
      level3Id: '城市',
      level4Id: '区/县',
      level5Id: '乡/镇/街道',
      level6Id: '社区',
      detailAddress: '详细地址',
      postalCode: '邮编'
    },
    placeholders: {
      priceNo: '请输入运价编码',
      id: '请输入ID',
      idList: '输入ID后回车，可输入多个',
      supplierIds: '请选择供应商',
      carrierIds: '请选择船公司',
      airCarrierIds: '请选择航空公司',
      cargoTypes: '请选择货物类型',
      select: '请选择',
      originCountryId: '请选择起运国家',
      destinationCountryId: '请选择目的国家',
      routeIds: '请选择卸货港航线',
      transitLocationIds: '请选择中转节点',
      polId: '请选择起运港',
      podId: '请选择卸货港',
      departureAirportId: '请选择起运机场',
      arrivalAirportId: '请选择目的机场',
      wharfIds: '请选择码头',
      loadingPortId: '请选择装货港',
      loadingStationId: '请选择装货站',
      warehouseId: '请选择仓库',
      nodeCountryId: '请选择国家',
      nodeSeaportId: '请选择海港',
      nodeTerminalId: '请选择码头',
      nodeAirportId: '请选择机场',
      destinationId: '请选择目的地',
      serviceType: '请输入服务类型',
      level1Id: '请选择国家/地区',
      level2Id: '请选择省/州',
      level3Id: '请选择城市',
      level4Id: '请选择区/县',
      level5Id: '请选择乡/镇/街道',
      level6Id: '请选择社区',
      detailAddress: '请输入详细地址',
      postalCode: '请输入邮编'
    },
    columns: {
      rateNo: '运价编码',
      rateType: '业务类型',
      source: '来源',
      supplierId: '供应商',
      carrierId: '承运人',
      originId: '起运地',
      destinationId: '目的地',
      prePortOrigin: '起运港',
      loadingLocation: '装货地',
      lastMileOrigin: '卸货港',
      deliveryLocation: '目的地',
      placeOfDeliveryId: '收货地',
      loadingPortId: '起运港',
      dischargePortId: '卸货港',
      destinationPortId: '目的港',
      terminalId: '码头',
      laneCode: '航线代码',
      priceSummary: '价格摘要',
      airMinimum: 'M（最低）',
      status: '状态',
      validDate: '有效期',
      operations: '操作'
    },
    result: {
      total: '{total} 条运价',
      listView: '列表视图',
      cardView: '卡片视图'
    },
    card: {
      departureAirport: '起飞机场',
      arrivalAirport: '到达机场',
      originPort: '起运港',
      destinationPort: '卸货港',
      mainTransport: '主干',
      transportSegment: '运输段',
      perShipment: '/票',
      perKg: '/KG',
      noRemarks: '暂无备注'
    },
    combination: {
      priceFields: {
        unitRate: '单价',
        minCharge: '最低收费',
        maxCharge: '最高收费'
      },
      loadingCountry: '起运国',
      loadingCountryPlaceholder: '请选择起运国',
      deliveryCountry: '目的国',
      deliveryCountryPlaceholder: '请选择目的国',
      warehouseLoadFailed: '加载仓库失败，请重试',
      destinationPort: '目的港',
      destinationPortPlaceholder: '请选择目的港',
      onePrice: 'ALL IN 价',
      precise: '精准组合',
      free: '自由组合'
    },
    actions: {
      search: '查询',
      reset: '重置',
      combinationQuery: '组合查询',
      detail: '查看详情',
      schedule: '查看船期',
      linkConsignment: '关联委托单'
    },
    detail: {
      title: '运价详情',
      rawData: '运价库原始详情'
    },
    schedule: {
      title: '查看船期',
      noMatched: '未匹配到实时船期数据，以下为运价维护的船期信息',
      columns: {
        vessel: '船名',
        voyage: '航次',
        laneCode: '航线代码',
        etd: 'ETD',
        eta: 'ETA',
        transitDays: '航程',
        routeEtd: '开航班期',
        cyClose: '截港时间',
        cutOff: '截关时间'
      }
    },
    enums: {
      yesNo: {
        yes: '是',
        no: '否'
      },
      directFlag: {
        direct: '直达',
        transit: '中转'
      },
      segmentTransportMode: {
        truck: '拖车',
        barge: '驳船',
        rail: '铁路'
      },
      addressType: {
        thirdParty: '第三方地址',
        warehouse: '仓库'
      },
      source: {
        inquiry: '询价入库',
        bidding: '招标入库',
        manual: '手工录入',
        system: '系统生成'
      },
      status: {
        normal: '正常',
        expired: '失效',
        disabled: '禁用'
      }
    },
    messages: {
      queryFailed: '运价查询失败',
      detailFailed: '运价详情加载失败',
      scheduleUnsupported: '当前业务类型不支持船期匹配',
      scheduleMissingCondition: '缺少船公司、起运港或卸货港，无法匹配船期',
      scheduleFailed: '船期匹配失败',
      linkTodo: '关联委托单将在下一阶段接入'
    }
  }
}
